export enum BRAND {
    TOPDANMARK = 'TD',
}
export enum PRODUCTKEY {
    B2B = 'B2B',
}

export enum PRODUCTKEYDK {
    B2B = 'Indbo',
}

export interface IProducts {
    productKey: PRODUCTKEY;
}

export enum EMAIL_IDENTIFIER {
    SALES_COMPLETE = 'SALES_COMPLETE',
    ORDER_QUOTE = 'ORDER_QUOTE',
    GENERAL_CALLME = 'GENERAL_CALLME',
}

export enum EMAIL_EVENT {
    UNKNOWN = 'UNKNOWN',
    BUY = 'BUY',
    GENERAL_ERROR = 'GENERAL_ERROR',
    IRRELEVANT_INDUSTRYCODE = 'IRRELEVANT_INDUSTRYCODE',
    TOO_MANY_EMPLOYEES = 'TOO_MANY_EMPLOYEES',
    STRICTER_CONDITIONS = 'STRICTER_CONDITIONS',
    OTHER_NEEDS = 'OTHER_NEEDS',
    TURNOVER_MIN = 'TURN_OVER_MIN',
    TURNOVER_MAX = 'TURN_OVER_MAX',
    BUSINESS_LINE_CLEANER = 'BUSINESS_LINE_CLEANER',
    BUSINESS_LINE_CARPENTER = 'BUSINESS_LINE_CARPENTER',
    YES_TO_CLAIMS = 'YES_TO_CLAIMS',
}

export enum BUSINESS_LINES {
    OFFICE_WORK = 'OFFICE_WORK',
    CLEANER = 'CLEANER',
    PAINTER = 'PAINTER',
    BRICKBUILDER = 'BRICKBUILDER',
    CARPENTER = 'CARPENTER',
}

export const maxTurnover = 5000000;

export interface IAdditionalCoverage {
    name: string;
    selected: boolean;
    turnOver: number;
}

export interface ICoverage {
    name: string;
    label?: string;
    selected?: boolean;
}
export interface ICoverageAmount {
    name: string;
    coverageAmount: number;
}

export interface IExstreamEmailPayloadCommon {
    identifier: EMAIL_IDENTIFIER;
    event: EMAIL_EVENT;
    fullName: string;
    emailAddress: string;
    phoneNumber: string;
    companyName: string;
    cvrNumber: string;
    industryCode: string;
    industryName: string;
    numberOfEmployees: number;
    packageName: string;
}

export interface IEmailPayloadBuy extends IExstreamEmailPayloadCommon {
    agreementDuration: number;
    existingBusinessInsurances: boolean;
    claims: boolean;
    numberOfClaims: number;
    effectiveDate: string;
    monthlyPrice: number;
    chargingAddress: string;
    insuranceAddress: string;
    bankRegistrationNumber: string;
    bankAccountNumber: string;
    coverages: Array<ICoverage>;
    coverageAmounts: Array<ICoverageAmount>;
    additionalCoverages?: Array<IAdditionalCoverage>;
    vanCallMe?: string;
    yearlyTurnover?: number;
    partnerName?: string;
    partnerDiscount?: string;
}

export interface IEmailPayloadQuote extends IExstreamEmailPayloadCommon {
    description?: string;
}

export interface IGeneralCallMeEmailTemplate {
    identifier: EMAIL_IDENTIFIER;
    event: EMAIL_EVENT;
    phoneNumber: string;
    fullName: string;
    email?: string;
    productName?: PRODUCTKEYDK;
    industryCode?: string;
    industryName?: string;
    companyName?: string;
    address?: string;
    zipCity?: string;
    cvrNumber?: string;
    employees?: number;
}

export interface ICoveragePackages {
    coverages: ICoverage[];
    monthlyPrice: number;
    packageName: string;
    totalMonthlyPrice: number;
    selectedColumn?: number;
}
